import React from 'react'
import { useState } from 'react';
import { Button, Modal } from 'react-bootstrap'
import Cards from 'react-credit-cards';
import InputField from '../../jsx/components/fields/inputField';
import PrimaryButton from '../../jsx/components/button/primaryButton';
import { lblEmail, lblPhoneNumber, txtMobileNumber } from '../../dataBaseFile/label';
import { validMobileNumberText } from '../../dataBaseFile/error'
import { emailValidation, phoneOnChange, phoneValidation } from '../../functions/validations';
import PhonenumberTagCompany from '../../jsx/components/fields/phonenumberTagCompany';
import ResponceToaster from '../../jsx/components/responceToaster/responceToaster';
import ResponceForAPI from '../../component/backDrop/responcesForAPI';
import { useDispatch } from 'react-redux';
import updatePaymentMethodById from '../../service/api/paymentGateway/updatePaymentMethodById';
import { useEffect } from 'react';
import EmailPhoneCombine from '../../jsx/components/fields/emailPhoneField';
import { isPostalCode } from 'validator';
import axios from 'axios';

const UpdateCardDetails = ({
    // particularPaymentMethodId,
    updateCardTrigger,
    handleCloseUpdateCard,
    // lastFourDigitCard,
    // initialMonthExpCard,
    // initialYearExpCard,
    // initialNameOnCard,
    particularCard,
}) => {
    const dispatch = useDispatch();

    const [lastFourDigitCard, setLastFourDigitCard] = useState('');
    const [initialMonthExpCard, setInitialMonthExpCard] = useState('');
    const [initialYearExpCard, setInitialYearExpCard] = useState('');
    const [initialNameOnCard, setInitialNameOnCard] = useState('');
    const [particularPaymentMethodId, setParticularPaymentMethodId] = useState('');

    console.log(particularCard, 'particularCard');

    const setInitialCardDetails = (particularCard) => {

        setParticularPaymentMethodId(particularCard?.id);
        setInitialNameOnCard(particularCard?.billing_details?.name);
        setLastFourDigitCard(`0000 0000 0000 ${particularCard?.card?.last4}`);
        if (particularCard?.card?.exp_month < 10) {
            setInitialMonthExpCard(`0${particularCard?.card?.exp_month}`);
        } else {
            setInitialMonthExpCard(particularCard?.card?.exp_month);
        }
        setInitialYearExpCard((particularCard?.card?.exp_year % 100).toString());
        setCompanyMail(particularCard?.billing_details?.email);

        particularCard?.billing_details?.phone && setcompanyPhone(particularCard?.billing_details?.phone);

        setZipCode(particularCard?.billing_details?.address?.postal_code);
    }

    useEffect(() => {
        setCardInfo({
            ...cardInfo,
            expiryDate: `${initialMonthExpCard}/${initialYearExpCard}`,
            cardHolder: initialNameOnCard,
        });
    }, [particularPaymentMethodId])

    useEffect(() => {
        setInitialCardDetails(particularCard);
    }, [])

    const [cardInfo, setCardInfo] = useState({
        expiryDate: `${initialMonthExpCard}/${initialYearExpCard}`,
        cardHolder: initialNameOnCard,
        focus: '',
    });

    // console.log(cardInfo, 'cardInfo');


    const [isCardHolderNameErr, setIsCardHolderNameErr] = useState(false);
    const [isCardExpErr, setIsCardExpErr] = useState(false);

    const [companyMail, setCompanyMail] = useState('');
    const [errorCompanyMail, setErrorCompanyMail] = useState(false);

    const [companyPhone, setcompanyPhone] = useState("");
    const [companyPhoneCode, setcompanyPhoneCode] = useState(1);
    const [isCompanyPhoneError, setIsCompanyPhoneError] = useState(false);

    const [responceMsg, setResponceMsg] = useState("");
    const [toasterType, setToasterType] = useState('');
    const [handleToaster, setHandleToaster] = useState(false);
    const [apiResponce, setApiResponse] = useState(false);

    const [zipCode, setZipCode] = useState("");
    const [isZipCodeErr, setIsZipCodeErr] = useState(false);
    const handleZipCode = (e) => {
        setIsZipCodeErr(false)
        // setZipCode(e.target.value.replace(/\D/g, ''))
        setZipCode(e.target.value)
    }

    const handleZipCodeBlurCheck = () => {
        // if (zipCode.trim() === '') {
        //     setIsZipCodeErr(true);
        // }
        validateZipCode();
    }

    const handleInputChange = (e) => {
        const { name, value } = e.target;

        if (name === 'cardHolder') {
            setIsCardHolderNameErr(false)
        }

        setCardInfo({
            ...cardInfo,
            [name]: value
        });
    };
    const handleCardHolderNameBlurCheck = () => {
        if (cardInfo.cardHolder.trim() === '') {
            setIsCardHolderNameErr(true);
        }
    }

    const handleExpiryDateChange = (e) => {
        setIsCardExpErr(false);
        let value = e.target.value?.replace(/\D/g, '');
        if (value.length > 4) value = value.substr(0, 4); // Maximum length of 4 digits
        if (value.length > 2) value = value.substr(0, 2) + '/' + value.substr(2); // Insert slash after two digits

        setCardInfo({
            ...cardInfo,
            expiryDate: value
        });
    };
    const handleCardExpBlurCheck = () => {
        const [month, year] = cardInfo.expiryDate.split('/');
        if (cardInfo.expiryDate.trim() === ""
            || cardInfo.expiryDate.trim().length != 5
            || Number(month) > 12
            || Number(year) < Number((new Date()).getFullYear().toString().slice(-2))) {
            setIsCardExpErr(true);
        }
    }

    const handleCompanyMail = (e) => {
        setErrorCompanyMail(false);
        setCompanyMail(e.target.value);
    }

    function handleEmailCompanyBlurCheck() {
        if (companyMail.length == 0) {
            setErrorCompanyMail(false);
        }
        else if (!emailValidation(companyMail)) {
            setErrorCompanyMail(true);
            if (!companyMail.includes('@') || !companyMail.includes('.com')) {
                setErrorCompanyMail(true);
                return;
            }
        }
    }

    const handleCountryCodeCompany = (e) => {
        // setcompanyPhoneCode(e.target.value)
        setcompanyPhoneCode(e)
    }

    const handleCompanyPhone = (e) => {
        setIsCompanyPhoneError(false);
        phoneOnChange(e.target.value) && setcompanyPhone(e.target.value);
    }
    const handleCompanyPhoneBlurCheck = () => {
        if (companyPhone.toString().length == 0) {
            setIsCompanyPhoneError(false);
        }
        else if (companyPhone.toString().length == 10) {
            setIsCompanyPhoneError(false);
        }
        else if (!phoneValidation(companyPhone)) {
            setIsCompanyPhoneError(true);
        }
    }
    const handleSubmitUpdate = (e) => {
        e.preventDefault();

        setApiResponse(true);

        const [month, year] = cardInfo.expiryDate.split('/');
        if (cardInfo.cardHolder.trim() === '') {
            setIsCardHolderNameErr(true);
            setApiResponse(false);
        }
        if (cardInfo.expiryDate.trim() === ""
            || cardInfo.expiryDate.trim().length != 5
            || Number(month) > 12
            || Number(year) < Number((new Date()).getFullYear().toString().slice(-2))) {
            setIsCardExpErr(true);
            setApiResponse(false);
        }

        const isValidZipCode = validateZipCode();

        if (!isValidZipCode) {
            setIsZipCodeErr(true);
            setApiResponse(false);
        }

        // if (zipCode?.trim() === '' || zipCode === null) {
        //     setIsZipCodeErr(true);
        //     setApiResponse(false);
        // }

        if ((cardInfo.cardHolder.trim() === '')
            || (cardInfo.expiryDate.trim() === "")
            || (cardInfo.expiryDate.trim().length != 5)
            || (Number(month) > 12)
            || (Number(year) < Number((new Date()).getFullYear().toString().slice(-2)))
            || isCompanyPhoneError
            || errorCompanyMail
            || (zipCode?.trim() === '') || zipCode === null || !isValidZipCode
        ) {
            setApiResponse(false);
            return
        }



        if (!isCardHolderNameErr && !isCardExpErr && !isCompanyPhoneError && !errorCompanyMail && !isZipCodeErr) {
            // console.log("Name:", cardInfo.cardHolder, "month:", month, "year:", year, "email", companyMail, "phone", companyPhone)
            // console.log("typeof:", typeof companyPhone)

            let details = new FormData();

            details.append("payment_method_id", particularPaymentMethodId);
            details.append("expiry_month", parseInt(month));
            details.append("expiry_year", parseInt(year));
            details.append("name_on_card", cardInfo.cardHolder);
            companyMail && details.append("email_chr", companyMail);
            companyPhone && details.append("phone_number", companyPhone);
            details.append("zip_code_chr", zipCode);
            details.append("country_code_chr", myCountryCode);

            dispatch(
                updatePaymentMethodById(
                    details,
                    (res) => {
                        // console.log(res)
                        setResponceMsg(res.data.message)
                        setToasterType("success")

                        handleCloseUpdateCard();
                        setApiResponse(false);

                        // setTimeout(() => {
                        //     handleCloseUpdateCard();
                        //     setApiResponse(false);
                        // }, 1500);

                        // setHandleToaster(true);
                        // setTimeout(() => {
                        //     setHandleToaster(false);
                        // }, 11000);
                    },
                    (res) => {
                        // console.log(res)
                        setResponceMsg(res.data.message)
                        setToasterType("error");

                        setApiResponse(false);

                        setHandleToaster(true);
                        setTimeout(() => {
                            setHandleToaster(false);
                        }, 11000);
                    }
                )
            )
        }
    }

    const [myCountryCode, setMyCountryCode] = useState('US');

    useEffect(() => {
        const getCountryCode = async () => {
            try {
                const response = await axios.get('https://ipapi.co/json/');
                const data = response.data;
                console.log(`'My country code:', ${data.country}`)
                setMyCountryCode(data.country);
            } catch (error) {
                console.log('Error fetching country code:', error);
            }
        };
        getCountryCode();
    }, []);

    const validateZipCode = () => {
        if (!zipCode) {
            setIsZipCodeErr(true);
            setApiResponse(false);
            return false;
        } else if (!isPostalCode(zipCode, myCountryCode || 'any')) {
            setIsZipCodeErr(true);
            setApiResponse(false);
            return false;
        }
        setIsZipCodeErr(false);
        return true;
    };


    return (
        <>
            {/* <!-- Modal --> */}
            <Modal className="fade" show={updateCardTrigger}
                // onHide={handleClose} 
                centered
            >
                <Modal.Body>
                    {/* New modal for update credit card details*/}
                    <div className='row mx-0'>
                        <div className='col-12 px-0'>

                            <>
                                <div className='mx-0 row'>
                                    <div className='col-12 d-flex fs-4 justify-content-end px-0 text-black'>
                                        <span onClick={() => handleCloseUpdateCard()} className='cursor-pointer'>
                                            <i className="bi bi-x-lg"></i>
                                        </span>
                                    </div>
                                </div>

                                <div className='mx-0 row mb-4'>
                                    <div className='col-12 font-w600 fs-3 px-0 text-center text-black '>
                                        <span>
                                            {"Update card details"}
                                        </span>
                                    </div>
                                </div>


                                <form onSubmit={handleSubmitUpdate}>

                                    {/* <div className='row mx-0'>
                                        <div className='col-12 px-0'>
                                            <Cards
                                                number={lastFourDigitCard}
                                                name={cardInfo.cardHolder ? cardInfo.cardHolder : initialNameOnCard}
                                                expiry={cardInfo.expiryDate ? cardInfo.expiryDate : `${initialMonthExpCard}${initialYearExpCard}`}
                                            />
                                        </div>
                                    </div> */}

                                    <div className='row mx-0 mb-3' >
                                        <div className='bg-white border col-12 mb-2 p-3 shadow-sm'>
                                            <div className='row mx-0'>
                                                <div className='col-12  px-0 d-flex align-items-center'>
                                                    {particularCard.is_default_card ? <div className='font-w600 mb-1 row text-success'>
                                                        {particularCard.is_default_card && <span>{"Primary payment method"}</span>}
                                                    </div> :
                                                        <>
                                                            <div className='d-flex fs-5 fw-bold text-black'>
                                                                <span>{`${(particularCard?.card?.brand).toUpperCase()} – *${particularCard?.card?.last4}`}</span>
                                                            </div>
                                                        </>
                                                    }



                                                </div>
                                            </div>

                                            {particularCard.is_default_card &&
                                                <div className='row mx-0'>
                                                    <div className='col-12  px-0'>
                                                        <div className='d-flex fs-5 fw-bold text-black'>
                                                            <span>{`${(particularCard?.card?.brand).toUpperCase()} – *${particularCard?.card?.last4}`}</span>
                                                        </div>
                                                    </div>
                                                </div>
                                            }


                                            <div className='row mx-0'>
                                                <div className='col-12  px-0 d-flex justify-content-between align-items-center'>
                                                    <div className='d-flex fs-6 font-w500 '>
                                                        <span>{`${cardInfo.cardHolder}`}</span>
                                                    </div>

                                                    <div className='d-flex fs-6 font-w500 '>
                                                        {/* <span>{`${particularCard?.card?.exp_month}/${particularCard?.card?.exp_year}`}</span> */}
                                                        <span>{`${cardInfo.expiryDate}`}</span>
                                                    </div>
                                                </div>

                                            </div>
                                        </div>
                                    </div>

                                    <div className='row mx-0'>
                                        <div className='col-12 px-0'>
                                            <InputField
                                                labelName="Name on card"
                                                placeholderName={'Cardholder Name'}
                                                type={'text'}
                                                name={'cardHolder'}
                                                value={cardInfo.cardHolder}
                                                onChange={handleInputChange}
                                                onBlur={handleCardHolderNameBlurCheck}
                                                errorOccured={isCardHolderNameErr}
                                                errorMeesage={'Enter valid cardholder name'}
                                                isRequired={true}
                                            />
                                        </div>
                                    </div>

                                    <div className='row mx-0 justify-content-between'>
                                        <div className='col-sm-6 px-0 pe-sm-2'>
                                            <InputField
                                                labelName="MM/YY"
                                                placeholderName={'MM/YY'}
                                                type={'text'}
                                                name={'expiryDate'}
                                                value={cardInfo.expiryDate}
                                                onChange={handleExpiryDateChange}
                                                // onFocus={handleInputFocus}
                                                onBlur={handleCardExpBlurCheck}
                                                errorOccured={isCardExpErr}
                                                errorMeesage={'Enter valid exp. date'}
                                                isRequired={true}
                                            />
                                        </div>

                                        <div className='col-sm-6 px-0  ps-sm-2'>
                                            <InputField
                                                labelName={"Zip code"}
                                                value={zipCode}
                                                onChange={(e) => { handleZipCode(e) }}
                                                onBlur={() => { handleZipCodeBlurCheck() }}
                                                errorOccured={isZipCodeErr}
                                                errorMeesage={`Enter valid zip code`}
                                                isRequired={true}
                                            />
                                        </div>
                                    </div>

                                    <div className='row mx-0'>
                                        <div className='col-12 px-0'>
                                            <InputField
                                                labelName={lblEmail}
                                                placeholderName={lblEmail}
                                                type={"email"}
                                                value={companyMail}
                                                onChange={handleCompanyMail}
                                                onBlur={handleEmailCompanyBlurCheck}
                                                errorOccured={errorCompanyMail}
                                                errorMeesage={"Please enter valid email"}
                                            />
                                        </div>
                                    </div>

                                    <div className='row mx-0'>
                                        <div className='col-12 px-0'>
                                            <EmailPhoneCombine
                                                inputValue={companyPhone}
                                                handleInputValue={handleCompanyPhone}
                                                errorOccured={isCompanyPhoneError}
                                                errorMessage={validMobileNumberText}
                                                handleChangeCode={(e) => handleCountryCodeCompany(e)}
                                                handleOnBlur={handleCompanyPhoneBlurCheck}
                                                isEnteringNumber={true}
                                                defaultCodeValue={companyPhoneCode}
                                                // label={txtMobileNumber}
                                                label={'Phone number'}
                                            />
                                        </div>
                                    </div>

                                    <div className='row mx-0 justify-content-between mt-2'>
                                        <div className='col-12 px-0  mb-2'>
                                            <PrimaryButton
                                                onClick={(e) => handleSubmitUpdate(e)}
                                                buttonName={"Update card"}
                                                type={"submit"}
                                                loadingMessage={"Loading..."}
                                                isLoading={apiResponce}
                                                style={{ width: "100%", background: 'green', border: 'none' }}
                                            />
                                        </div>
                                    </div>

                                </form>
                            </>



                        </div>
                    </div>
                </Modal.Body>
            </Modal>

            {/* <div>
                        <Cards
                            number={lastFourDigitCard}
                            name={cardInfo.cardHolder ? cardInfo.cardHolder : initialNameOnCard}
                            expiry={cardInfo.expiryDate ? cardInfo.expiryDate : `${initialMonthExpCard}${initialYearExpCard}`}
                        />
                    </div>
                    <form onSubmit={handleSubmitUpdate} style={{ marginTop: '20px' }}>

                        <InputField
                            labelName="Cardholder Name *"
                            placeholderName={'Cardholder Name'}
                            type={'text'}
                            name={'cardHolder'}
                            value={cardInfo.cardHolder}
                            onChange={handleInputChange}
                            onBlur={handleCardHolderNameBlurCheck}
                            errorOccured={isCardHolderNameErr}
                            errorMeesage={'Enter valid cardholder name'}
                        />


                        <div className='combine-input-fileds' >
                            <div className='comapany-address' style={{ width: '49%' }}>
                                <InputField
                                    labelName="Expiry Date *"
                                    placeholderName={'MM/YY'}
                                    type={'text'}
                                    name={'expiryDate'}
                                    value={cardInfo.expiryDate}
                                    onChange={handleExpiryDateChange}
                                    onBlur={handleCardExpBlurCheck}
                                    errorOccured={isCardExpErr}
                                    errorMeesage={'Enter valid exp. date'}
                                />
                            </div>

                            <div className='comapany-address' style={{ width: '49%' }}>
                                <InputField
                                    labelName={lblEmail}
                                    placeholderName={lblEmail}
                                    type={"email"}
                                    value={companyMail}
                                    onChange={handleCompanyMail}
                                    onBlur={handleEmailCompanyBlurCheck}
                                    errorOccured={errorCompanyMail}
                                    errorMeesage={"Please enter valid email"}
                                />
                            </div>
                        </div>

                        <PhonenumberTagCompany
                            placeholder={lblPhoneNumber}
                            value={companyPhone}
                            // defaultValue={companyPhoneCode}
                            handleChangeCode={(e) => handleCountryCodeCompany(e)}
                            onChange={handleCompanyPhone}
                            onBlur={handleCompanyPhoneBlurCheck}
                            errorOccured={isCompanyPhoneError}
                            errorMessage={"Please enter valid phone number"}

                        />

                        <div className='d-flex align-items-center' style={{ marginTop: '10px', justifyContent: 'flex-end' }}>

                            <PrimaryButton
                                buttonName={"Update details"}
                                onClick={handleSubmitUpdate}
                            />
                        </div>
                    </form> */}

            {handleToaster && <ResponceToaster toasterType={toasterType} message={responceMsg} />}
            {/* {apiResponce && <ResponceForAPI show={apiResponce} />} */}
        </>
    )
}

export default UpdateCardDetails